import Switch from './switch'
import Image from './image'
import Text from './text'
import Actions from './actions'
import Checkbox from './checkbox'
import TextWithDescription from './text-with-description'

const ComponentsList = {
  Switch,
  Image,
  Text,
  Actions,
  Checkbox,
  TextWithDescription,
}

export default ComponentsList
